import React from 'react';

import ImportShow from '@components/shared/imports/ImportShow';
import { useLoaderData } from 'react-router-dom';

export default function AdminImportShow() {
  const importData = useLoaderData();

  return (
    <ImportShow
      importData={importData}
      role="admin"
    />
  );
}
